<template>
  <div class="menu-page col-md-6 offset-md-3 col-xs-12">
    <div class="container page">
      <fieldset :disabled="inProgress">
        <legend>
          <h1>菜單</h1>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th style="min-width:7rem;">餐點名稱</th>
              <th style="min-width:4rem;">價格</th>
              <th style="min-width:4rem;">數量</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(meal, index) in menu.menuMeal">
              <template v-if="meal.status=='show'">
                <tr :key="index">
                  <td>{{meal.name}}</td>
                  <td>{{meal.price}}</td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="meal.quantity"
                      placeholder="請輸入"
                    />
                  </td>
                </tr>
                <tr :key="'des'+index">
                  <td v-if="meal.inventory>0" class="text-right" colspan="3">
                    {{meal.description}}，限量{{meal.inventory}}份售完為止
                  </td>
                  <td v-else class="text-right" colspan="3">
                    售完
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </fieldset>
      <hr />
      <div class="input-group mt-2 col-md-10 offset-md-2 col-xs-12">
        <div class="input-group-prepend">
          <span class="input-group-text">取餐地點</span>
        </div>
        <select class="custom-select" v-model.number:="menu.deliveryLocation">
          <template v-for="(location, index) in signboard.deliveryLocation">
            <option :value="location" :key="index">{{location}}</option>
          </template>
        </select>
      </div>
      <div class="input-group mt-2 col-md-6 offset-md-6 col-xs-12">
        <div class="input-group-prepend">
          <span class="input-group-text">取餐時間</span>
        </div>
        <select class="custom-select" v-model.number:="menu.deliveryTime">
          <template v-for="(time, index) in signboard.deliveryTime">
            <option :value="time" :key="index">{{time}}</option>
          </template>
        </select>
      </div>
      <div class="input-group mt-2 col-md-6 offset-md-6 col-xs-12">
        <div class="input-group-prepend">
          <span class="input-group-text">最小金額</span>
        </div>
        <input
          type="number"
          class="form-control"
          readonly="true"
          v-model.number="menu.minPrice"
        />
      </div>
      <hr />
      <button
        @click="menuQuantityToOrder(menu)"
        :disabled="inProgress"
        class="btn btn-block btn-secondary"
      >確定</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  name: "Menu",
  methods: {
    menuQuantityToOrder(menu) {
      let amount = 0;
      for (let k in menu.menuMeal) {
        if (menu.menuMeal[k].quantity) {
          amount += menu.menuMeal[k].price * menu.menuMeal[k].quantity;
        }
      }
      if (amount < menu.minPrice) {
        alert("金額不足");
        return false;
      }
      if (menu.status == "on") {
        this.$store.dispatch("menuQuantityToOrder", menu);
        this.$router.push({ name: "editor-order" });
      } else {
        alert("點餐功能未開啟，請稍後在試");
        this.$router.push({ name: "home" });
      }
    }
  },
  async beforeRouteEnter(to, from, next) {
    store.dispatch("fetchMenu", to.params.slug);
    store.dispatch("fetchSignboard", to.params.slug);
    return next();
  },
  async beforeRouteUpdate(to, from, next) {
    store.dispatch("fetchMenu", to.params.slug);
    return next();
  },
  data() {
    return {
      inProgress: false,
      errors: {}
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["menu", "signboard"])
  }
};
</script>
